import { queryOptions, useQuery } from '@tanstack/react-query'
import { authService } from 'api'
import { useAuthQueryKey } from './use-auth-query-key'

export const authQueryOptions = queryOptions({
  queryKey: useAuthQueryKey(),
  queryFn: () => authService.onAuthStateChanged(),
  staleTime: Infinity,
  gcTime: Infinity,
})

export function useAuth() {
  return useQuery(authQueryOptions)
}
